module.exports = __webpack_public_path__ + "img/kebhana.291cea81.png";